import { AfterViewInit, Component, EventEmitter, Inject, Input, Optional, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Szme037aResponseCdtmnySyosaiRefInfDto, Szme038aResponse } from 'sg-api';
import { Szme038aResponseCdtmnyMeisaiInfDto } from 'sg-api';
// import { EXTENSION_POINT_CONFIG, ExtensionPointConfig } from '../../../../../../pluggable/extension-point-config';
import { DateDurationPipe } from '../../../../../sg-kd-shared/pipes/date-duration.pipe';

/**
 * 売掛金詳細（内訳）画面
 * @export
 * @class UrikakekinElectricDetailUchiwakeComponent
 * @implements {AfterViewInit}
 */
@Component({
  selector: 'app-urikakekin-electric-detail-uchiwake',
  templateUrl: './urikakekin-electric-detail-uchiwake.component.html',
  styleUrls: ['./urikakekin-electric-detail-uchiwake.component.scss'],
  providers: [DateDurationPipe]
})
export class UrikakekinElectricDetailUchiwakeComponent implements AfterViewInit {
  /** 売掛金詳細画面情報 */
  @Input() szme038aResponse: Szme038aResponse;

  @Input() urikakekinInfo: Szme037aResponseCdtmnySyosaiRefInfDto;

  @Input() electricDetailUchiwake: Szme038aResponseCdtmnyMeisaiInfDto[];

  @Input() prdClsfyDiv: string; 
  
  @Output() clickEvent = new EventEmitter();

  /** ResponseCustomize 表示領域 */
  @ViewChild('extension_point', { read: ViewContainerRef })
  extensionPointRef!: ViewContainerRef;

  /** 画面表示項目 */
  displayedColumns: string[] = [
    'itemAname',
    'meisaiInfText01',
    'meisaiInf03',
    'meisaiInf02',
    'meisaiInf01',
  ];

  constructor() {
  }
  // constructor(@Optional() @Inject(EXTENSION_POINT_CONFIG) private config: ExtensionPointConfig) {
  // }

  /**
* クリック処理
* @param {*} event
* @return {*} {void}
* @memberof UrikakekinElectricDetailUchiwakeComponent
*/
  onClick(): void {
    // コンテナにイベント通知
    this.clickEvent.emit();
  }

  /**
     * 動的コンポーネントロード処理の呼び出し
     * @memberof UrikakekinElectricDetailUchiwakeComponent
     */
  ngAfterViewInit(): void {
    // this.loadDynamicComponent();
  }


  // /**	
  //  * 動的コンポーネントのロード処理	
  //  * @private	
  //  * @memberof UrikakekinElectricDetailUchiwakeComponent	
  //  */
  // private loadDynamicComponent() {
  //   if (this.config?.szme038aResponseCustomize) {
  //     // 拡張コンポーネントのViewContainerをクリア	
  //     this.extensionPointRef.clear();
  //     // 動的コンポーネントローダーにて拡張コンポーネントをロード	
  //     const ref = this.extensionPointRef.createComponent(this.config.szme038aResponseCustomize);
  //     // レスポンスを動的コンポーネントのインスタンスに設定	
  //     ref.instance.response = this.szme038aResponse;
  //   }
  // }

}
